// extracted by mini-css-extract-plugin
export default {"dialog":"Dialog_dialog__s1mgf","cancel":"Dialog_cancel__whXaW","dialog__content":"Dialog_dialog__content__eweHn"};